import { render, staticRenderFns } from "./ContentPageLayout.vue?vue&type=template&id=0e16a864&scoped=true"
import script from "./ContentPageLayout.vue?vue&type=script&lang=js"
export * from "./ContentPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e16a864",
  null
  
)

export default component.exports